var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTran(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFEDE3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4249 21.125H11.2666C10.9249 21.125 10.6416 20.8417 10.6416 20.5V16.2333C10.6416 15.3667 11.3499 14.6583 12.2166 14.6583H14.4249C14.7666 14.6583 15.0499 14.9417 15.0499 15.2833V20.4917C15.0499 20.8417 14.7666 21.125 14.4249 21.125ZM11.8916 19.875H13.7999V15.9167H12.2166C12.0416 15.9167 11.8916 16.0583 11.8916 16.2416V19.875Z",
    fill: "#F7936F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5751 21.125H14.4167C14.0751 21.125 13.7917 20.8417 13.7917 20.5V12.45C13.7917 11.5833 14.5001 10.875 15.3667 10.875H16.6334C17.5001 10.875 18.2084 11.5833 18.2084 12.45V20.5C18.2001 20.8417 17.9251 21.125 17.5751 21.125ZM15.0501 19.875H16.9584V12.45C16.9584 12.275 16.8168 12.125 16.6334 12.125H15.3667C15.1917 12.125 15.0417 12.2667 15.0417 12.45V19.875H15.0501Z",
    fill: "#F7936F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7335 21.125H17.5752C17.2335 21.125 16.9502 20.8416 16.9502 20.5V16.7083C16.9502 16.3666 17.2335 16.0833 17.5752 16.0833H19.7835C20.6502 16.0833 21.3585 16.7916 21.3585 17.6583V20.5C21.3585 20.8416 21.0835 21.125 20.7335 21.125ZM18.2002 19.875H20.1085V17.6583C20.1085 17.4833 19.9669 17.3333 19.7835 17.3333H18.2002V19.875Z",
    fill: "#F7936F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5001 24.9583H13.5001C8.97508 24.9583 7.04175 23.025 7.04175 18.5V13.5C7.04175 8.97496 8.97508 7.04163 13.5001 7.04163H18.5001C23.0251 7.04163 24.9584 8.97496 24.9584 13.5V18.5C24.9584 23.025 23.0251 24.9583 18.5001 24.9583ZM13.5001 8.29163C9.65841 8.29163 8.29175 9.65829 8.29175 13.5V18.5C8.29175 22.3416 9.65841 23.7083 13.5001 23.7083H18.5001C22.3417 23.7083 23.7084 22.3416 23.7084 18.5V13.5C23.7084 9.65829 22.3417 8.29163 18.5001 8.29163H13.5001Z",
    fill: "#F7936F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTran);
export default __webpack_public_path__ + "static/media/tran.f93b02afd504d8c4d1f20f57a0e848e0.svg";
export { ForwardRef as ReactComponent };